import { modifier } from "ember-modifier"

/*
Vendored from https://github.com/alexlafroscia/ember-intersection-observer-modifier

The MIT License (MIT)

Copyright (c) 2020 alexlafroscia (Alex LaFroscia )

Permission is hereby granted, free of charge, to any person obtaining a copy of this software and associated documentation files (the "Software"), to deal in the Software without restriction, including without limitation the rights to use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of the Software, and to permit persons to whom the Software is furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
*/

/**
 * @param {HTMLElement} element
 * @param {[IntersectionObserverCallback, Partial<IntersectionObserverInit>]} positionalParams
 * @param {Partial<IntersectionObserverInit>} hashOptions
 */
function observeIntersection(element, [callback, optionsObject], hashOptions) {
  const options = { ...optionsObject, ...hashOptions }

  const observer = new IntersectionObserver(callback, options)
  observer.observe(element)

  return function cleanupObserver() {
    observer.disconnect()
  }
}

export default modifier(observeIntersection)
